export enum TableCheckState {
    NOT_EXISTING = "NOT_EXISTING",
    NOT_A_MEMBER = "NOT_A_MEMBER",
    OK = "OK"
}

export default class TableCheckResult {
    state?: TableCheckState
}